import { type EditorView } from 'prosemirror-view'
import { Plugin } from 'prosemirror-state'
import { Slice } from 'prosemirror-model'

// NOTE: Because `defining` on node specs also affects copying, we need to use
// a plugin to preserve lists with one list item with one text wrap node which
// we paste into (otherwise the list item disappears).
export const PreserveListItemOnPaste = new Plugin({
  props: {
    handlePaste: (
      {
        dispatch,
        state: {
          schema,
          selection: { $from, empty, from, to },
          tr,
        },
      }: EditorView,
      event: Event,
      slice: Slice,
    ) => {
      if (!empty) return false
      if ($from.depth < 1) return false

      const maybeListItem = $from.node($from.depth - 1)
      if (maybeListItem.type !== schema.nodes.list_item) return false

      const list = $from.node($from.depth - 2)
      if (list.childCount !== 1) return false

      if (maybeListItem.childCount !== 1) return false
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (maybeListItem.firstChild!.childCount !== 0) return false

      const listItemStart = $from.start($from.depth - 1)
      const listItemEnd = $from.end($from.depth - 1)
      tr.replace(listItemStart, listItemEnd, slice)
      dispatch(tr)

      return true
    },
  },
})
